const postChangeHostBulkRequest = (payload) => {
  const allDetails = payload.flatMap((brand) => brand.details);

  return {
    updates: allDetails
      .filter((detail) => detail.status === 'update' && detail.selectedHosts?.length)
      .map((detail) => ({
        scheduleId: detail.id,
        hostIds: detail.selectedHosts?.map((host) => host.value) ?? [],
      })),
    deletes: allDetails.filter((detail) => detail.status === 'delete').map((detail) => detail.id),
  };
};

export default postChangeHostBulkRequest;
